








import Vue from 'vue';
import Component from 'vue-class-component';
import CommonApi from '@/api/CommonApi';
import {Prop} from 'vue-property-decorator';
import {CodeRetrieveResponse} from '@/model/CommonModel';
import ApiUtils from '@/utils/ApiUtils';
import {ComponentEventBus} from '@/store';

@Component
export default class AppendixSelectInput extends Vue {
    @Prop({default: ''}) private readonly appendix: string;
    @Prop({default: 'small'}) private readonly size: string;
    private appendixes: CodeRetrieveResponse[] = [];

    get value() {
        return this.$route.meta.isAdmin ? null : this.appendix;
    }

    get selectSize() {
        return this.size;
    }

    get getAppendixes() {
      return  this.$route.meta.isAdmin ? [] : this.appendixes;
    }

    public mounted() {
        this.init();
        ComponentEventBus.$on('sponsorChanged', (sponsorKey: string) => {
            this.init();
        });

        ComponentEventBus.$on('settingsChanged', () => {
          this.init();
        });
    }

    private init() {
        if (this.$route.meta.isAdmin) {
          return;
        }
        CommonApi.retrieveCodes('USE_APPENDIX').then(res => {
            const appendixes = res.data?.codeList ?? [];
            if (!appendixes.find((item: CodeRetrieveResponse) => item.codeValue === this.$route.params.appendix)) {
                this.$router.push({
                    name: this.$route.name === 'AdminSettings' ? 'AdminSettings' : 'Home',
                    params: {
                        ...ApiUtils.extractRequiredParams(this.$route.params),
                        appendix: appendixes[0].codeValue
                    }
                });
            }
            this.appendixes = appendixes;
        });
    }

    public onChangeInput(data: any) {
        this.$store.commit('setAppendix', data);
    }

    public destroyed() {
        ComponentEventBus.$off('sponsorChanged');
        ComponentEventBus.$off('settingsChanged');
    }
}
